import { useContext } from 'react';
import { ChangeVisiblePreviewContext, VisiblePreviewContext } from './Provider';

export const useVisiblePreview = () => useContext(VisiblePreviewContext);
export const useSetVisiblePreview = () =>
  useContext(ChangeVisiblePreviewContext);
